import React, { FC, useLayoutEffect, useMemo } from 'react';

import { useLocation } from 'application/providers/RouterProvider';
import { useAccountCompanyId, useAccountIsReadyToUseLK } from 'application/hooks';

import { useGetNotifications } from 'domain/media/useGetNotifications';

import { GeneratedReportsContext } from './GeneratedReportsContext';

const GeneratedReportsProvider: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const notifications = useGetNotifications();

  const value = useMemo(
    () => ({
      notifications: notifications?.data,
    }),
    [notifications]
  );

  const { pathname } = useLocation();

  const companyId = useAccountCompanyId();
  const isReadyToUseLK = useAccountIsReadyToUseLK();

  useLayoutEffect(() => {
    if (companyId && isReadyToUseLK) {
      notifications?.refetch();
    }
  }, [pathname, companyId, isReadyToUseLK]);

  return <GeneratedReportsContext.Provider value={value}>{children}</GeneratedReportsContext.Provider>;
};

export default GeneratedReportsProvider;
